import {match} from 'ts-pattern';

import {omit} from 'ramda';

import {type PutTenantV2ApiReq} from '@dms/api/base';

import {COMPANY_TYPE} from '../constants/COMPANY_TYPE';
import {SELF_EMPLOYED_TYPE} from '../constants/SELF_EMPLOYED_TYPE';
import {type TenantType} from '../types/TenantType';
import {normalizeSelfEmployedInformation} from './normalizeSelfEmployedInformation';
import {type FormValues} from './types';

export const normalizeContactInformation = (
  type: TenantType,
  contactInformation: FormValues['contactInformation']
): PutTenantV2ApiReq['contactInformation'] => ({
  ...contactInformation,
  address: omit(['externalAddressId'], contactInformation.address),
  selfEmployedInformation: match<
    TenantType,
    PutTenantV2ApiReq['contactInformation']['selfEmployedInformation']
  >(type)
    .with(COMPANY_TYPE, () => null)
    .with(SELF_EMPLOYED_TYPE, () =>
      normalizeSelfEmployedInformation(contactInformation.selfEmployedInformation)
    )
    .exhaustive(),
});
